import React, { FC } from 'react';

type Props = {
  vertical?: string;
  horizontal?: string;
};

const Spacer: FC<Props> = ({ vertical = 0, horizontal = 0 }) => {
  return (
    <div
      style={{
        paddingTop: vertical,
        paddingLeft: horizontal,
      }}
    />
  );
};

export default Spacer;
